import { InjectionToken } from '@angular/core';

export const IS_CORDOVA = new InjectionToken<boolean>('Is Cordova');
export const CORDOVA_EXTERNAL_APP_DOMAIN = new InjectionToken<string>('Cordova external app domain');
export const CORDOVA_INTERNAL_IOS_APP_DOMAIN = new InjectionToken<string>('Cordova internal iOS app domain');
export const CORDOVA_INTERNAL_ANDROID_APP_DOMAIN = new InjectionToken<string>('Cordova internal Android app domain');
export const CORDOVA_WEB_DOMAIN = new InjectionToken<string>('Cordova web domain');
export const CORDOVA_ANDROID_NOTIFICATION_CHANNELS = new InjectionToken<string>('Notification Channel definition');
